var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInformationCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.066 4.867A.889.889 0 0 0 8.2 4a.889.889 0 0 0-.867.867.85.85 0 0 0 .867.866.85.85 0 0 0 .866-.866Zm-1.844 6.466h2.222c.333 0 .556-.157.556-.472 0-.314-.223-.524-.556-.524H9c-.056 0-.111-.052-.111-.105V7.715c0-.577-.5-1.048-1.112-1.048h-.555c-.333 0-.556.21-.556.524 0 .315.223.524.556.524h.444c.056 0 .111.053.111.105v2.36c0 .052-.055.105-.11.105h-.445c-.333 0-.556.21-.556.524 0 .315.223.524.556.524Zm.778-10c-3.667 0-6.667 3-6.667 6.667s3 6.667 6.667 6.667c3.666 0 6.666-3 6.666-6.667s-3-6.667-6.666-6.667Z",
  fill: "#125598"
})));
export default SvgInformationCircle;